import { factory } from './base';

export interface WinnerD {
  at: number;
  betAmountCents: number;
  currency: string;
  gameIdentifier: string;
  gameTableImagePath: string;
  gameTableUrl: string;
  gameTitle: string;
  humanizedWin: string;
  nickname: string;
  winAmountCents: number;
  index?: number;
}

export interface Winner extends WinnerD {
  path: string | undefined;
}

export const latestWinners = factory(
  (r) => () => r<WinnerD[]>('get', 'stats/winners/latest')
);
